import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { partnerListAll } from "@/api/partner";
export var gamePartner = {
  namespaced: true,
  state: {
    isInit: 0,
    partnerKv: {}
  },
  mutations: {
    setPartnerKv: function setPartnerKv(state, partnerMap) {
      state.isInit = 1;
      state.partnerKv = partnerMap;
    }
  },
  actions: {
    getPartner: function getPartner(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, partnerMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return partnerListAll();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                partnerMap = {};
                res.data.list.forEach(function (val) {
                  partnerMap[val.partner_id] = val.partner_name;
                });
                commit("setPartnerKv", partnerMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    partnerMap: function partnerMap(state) {
      return state.partnerKv;
    }
  }
};